import {InputProps} from "../models/Inputs/InputProps";
import InputSwitch from "../ui/Inputs/InputSwitch/InputSwitch";
import React from "react";

const renderInputs = (items: InputProps[], key: string, wrapperClass = '', inputWrapperClass = '', formikMeta: any = {}) => (
    <div className={wrapperClass}>
        {items.map((value: InputProps, index: number) => (
            <div className={'d-flex flex-row align-items-center ' + inputWrapperClass} key={`${key}-${value.name}-${index}`}>
                {!value.noLabel && <label className={'col-4'}>{value.placeholder}</label>}
                {InputSwitch({...value, placeholder: !!value.noLabel ? value.placeholder : undefined}, formikMeta)}
            </div>
        ))}
    </div>
)

export default renderInputs;
